import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-my",
  "use": "icon-my-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-my\"><path d=\"m22.535 17.1-.445-.305-.365.39c-1.336 1.435-3.236 2.33-5.345 2.33s-4.009-.895-5.341-2.326l-.004-.004-.37-.39-.44.305c-2.886 1.991-4.756 5.276-4.765 8.999v.471a2.03 2.03 0 0 0 2.03 2.03H25.27a2.03 2.03 0 0 0 2.03-2.025v-.47a10.917 10.917 0 0 0-4.728-8.981l-.037-.024zm1.02-6.32c0 3.963-3.212 7.175-7.175 7.175s-7.175-3.212-7.175-7.175c0-3.963 3.212-7.175 7.175-7.175s7.175 3.212 7.175 7.175z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol